<template>
  <footer>
    <p>Copyright &copy; EricL81 - 2021</p>
    <router-link to="/about">About</router-link>
    <br>
    <br>
    <h5>* double-click to set/remove reminder</h5>
  </footer>
</template>

<script>
export default {};
</script>

<style scoped>
a {
  color: #333;
}

h5 {
  color : rgb(65, 64, 64);
}
footer {
  margin-top: 30px;
  text-align: center;
}
</style>